export default {
    handler: {
        dismiss: {
            subject: "即将放弃注册",
            text: "请确认后执行"
        }
    }
}
